var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPrivateLabel = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  style: {
    enableBackground: "new 0 0 263.6 158.5"
  },
  viewBox: "0 0 263.6 158.5",
  ref: svgRef
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#2d2729}.st1{fill:none;stroke:#fff;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st2{fill:#fff}.st3{stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.st3,.st4,.st5{fill:none;stroke:#000}.st4{stroke-width:1.5;stroke-miterlimit:10}.st5{stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:7.5407,7.5407}.st6{fill:#191a1a}.st10,.st11,.st12{stroke-miterlimit:10}.st10{stroke:#000;stroke-width:1.5}.st11,.st12{fill:none;stroke:#070707}.st12{stroke:#000;stroke-width:2}.st13,.st14{fill-rule:evenodd;clip-rule:evenodd;fill:#0f0f08}.st14{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
  d: "M40.3 144.9h193.1c2.8 0 5.1-2.3 5.1-5.1V13.3c0-2.8-2.3-5.1-5.1-5.1H40.3c-2.8 0-5.1 2.3-5.1 5.1v126.5c0 2.8 2.3 5.1 5.1 5.1z",
  style: {
    stroke: "#000",
    strokeMiterlimit: 10
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.2 33.2h203.3v22.7H35.2z",
  style: {
    fill: "#f4f4f4"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.2 118.3H209c5.8 0 10.6-4.7 10.6-10.6v-7.5c0-5.8-4.7-10.6-10.6-10.6h-21.8c-5.8 0-10.6 4.7-10.6 10.6v7.5c0 5.9 4.8 10.6 10.6 10.6z",
  style: {
    fill: "#9d9d9d"
  }
}));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPrivateLabel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconPrivateLabel.ab319f30.svg";
export { ForwardRef as ReactComponent };